import styles from "../../assets/styles/layout.module.css"
import logo from "../../assets/images/layout/sidebarlogo.png"
import plusLogo from "../../assets/images/layout/pluslogo.png"
import SidebarData from "./SidebarData"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch, RootState } from "../../utils/store"
import React, { useEffect, useState } from "react"
import { handleToggle } from "../../utils/store/common/CommonSlice"
import { getActivePortalModulesApi } from "../../utils/api/services"

interface PortalModule {
    id: number;
    module_name: string;
    module_key: string;
    sort_order: number;
}

// "lab_tests", "LabTests" and "Book Lab tests" compare as "labtest" / "booklabtest" (case, separators and plural "s" ignored)
const normalize = (value?: string) => (value || '').toLowerCase().replace(/[^a-z0-9]/g, '').replace(/s$/, '');

const matchesModule = (item: SidebarDataType, module: PortalModule) => {
    const itemKeys = [normalize(item.title), normalize(item.path)];
    return [normalize(module.module_key), normalize(module.module_name)]
        .filter(Boolean)
        .some((key) => itemKeys.includes(key));
}

// no active modules (or the call fails) -> show every item; otherwise only the active ones, in their order
const buildMenu = (modules: PortalModule[] | undefined): SidebarDataType[] => {
    if (!modules || modules.length === 0) return SidebarData;
    const menu: SidebarDataType[] = [];
    [...modules]
        .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))
        .forEach((module) => {
            const item = SidebarData.find((sidebarItem) => matchesModule(sidebarItem, module));
            if (item && !menu.includes(item)) menu.push(item);
        });
    return menu.length > 0 ? menu : SidebarData;
}

const Sidebar = () => {
    const { sidebarToggle } = useSelector((state: RootState) => state.common)
    const { isCareNavigator, token } = useSelector((state: RootState) => state.auth)
    const [menuItems, setMenuItems] = useState<SidebarDataType[]>(SidebarData)
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        if (!token) return;
        let cancelled = false;
        getActivePortalModulesApi()
            .then((result) => {
                if (!cancelled) setMenuItems(buildMenu(result?.success ? result?.modules : undefined));
            })
            .catch(() => {
                if (!cancelled) setMenuItems(SidebarData);
            });
        return () => { cancelled = true; };
    }, [token]);

    const handleNavigate = (item: SidebarDataType) => {
        navigate(item.path)
        if (window.innerWidth <= 768) {
            dispatch(handleToggle(true));
        }
    }

    return (
        <div className={`${styles.sidebarMain} ${sidebarToggle ? styles.toggle : ''}`}>
            <div className={`${sidebarToggle ? styles.sidebarLogoToggle : styles.sidebarLogo}`}>
                <img src={sidebarToggle ? plusLogo : logo} alt="logo" />
            </div>
            <ul className={styles.sidebarItemsMain}>
                {
                    menuItems?.map((item, index) => {
                        const isActive = location.pathname.startsWith(item.path);
                        return (
                            <React.Fragment key={index}>
                                {
                                    item?.title === 'Talk to Doctor' && isCareNavigator ?
                                        <li key={index} className={isActive ? styles.ActiveLink : ''}>
                                            <div className={styles.sidebarIcon}>
                                                <item.icon />
                                            </div>
                                            <Link to={"#"}>{item?.title}</Link>
                                        </li>
                                        :
                                        <li key={index} className={isActive ? styles.ActiveLink : ''} onClick={() => handleNavigate(item)}>
                                            <div className={styles.sidebarIcon}>
                                                <item.icon />
                                            </div>
                                            <Link to={item.path}>{item?.title}</Link>
                                        </li>
                                }
                            </React.Fragment>
                        )
                    })
                }
            </ul>
        </div>
    )
}

export default Sidebar